var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwitchOnDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 18,
    viewBox: "0 0 32 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 17,
    rx: 8.5,
    stroke: "#EEEEEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 15C26.3137 15 29 12.3137 29 9C29 5.68629 26.3137 3 23 3C19.6863 3 17 5.68629 17 9C17 12.3137 19.6863 15 23 15Z",
    fill: "#00FFE0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchOnDark);
export default __webpack_public_path__ + "static/media/switchOnDark.f3f64cf2b85bb10f93b1210c0c1949c5.svg";
export { ForwardRef as ReactComponent };